import { OperacaoVazaoService } from 'src/app/services/operacoes/operacao-vazao/operacao-vazao.service';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-stripping-cow',
  templateUrl: './stripping-cow.component.html',
  styleUrls: ['./stripping-cow.component.scss'],
})
export class StrippingCowComponent implements OnInit {
 
  public title: string;
  public caladoSaida:any = 0;
  private id_operacao: number;
  private id_operacaoLote: number;

  public stripping = {
    begin: '',
    end: ''
  };
  public cowTime = {
    begin: '',
    end: ''
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<StrippingCowComponent>,
    private operacaoVazaoService: OperacaoVazaoService
  ) {
    // const getHour = (date) =>{
    //   const data = new Date(date);
    //   return `${data.getHours().toString().padStart(2, '0')}:${data.getMinutes().toString().padStart(2, '0')}`
    // }

    this.id_operacao = data.id_operacao;
    this.id_operacaoLote = data.lote.id_operacaoLote;

    this.title = data.title;
    this.stripping = {
      begin: data.lote.strippingInicio? this.getStrippingTime(data.lote.strippingInicio) : '', 
      end: data.lote.strippingFim? this.getStrippingTime(data.lote.strippingFim) : '' 
    }
    this.cowTime = {
      begin: data.lote.cowInicio? this.getStrippingTime(data.lote.cowInicio) : '', 
      end: data.lote.cowFim? this.getStrippingTime(data.lote.cowFim) : '' 
    }
  }

  ngOnInit() { }

  public validateTimes(){
    if(this.stripping.begin && this.stripping.begin.length<5) return true
    if(this.stripping.end && this.stripping.end.length<5) return true
    if(this.cowTime.begin && this.cowTime.begin.length<5) return true
    if(this.cowTime.end && this.cowTime.end.length<5) return true
    return false
  }

  private getStrippingTime(date){
    if(date){
      const time = new Date(new Date(date).setHours(new Date(date).getHours()));
      // console.log(date);
      
      // console.log(time.toISOString());
      // debugger
      const day = time.getDate().toString().padStart(2,'0');
      const month = (time.getMonth()+1).toString().padStart(2,'0');
      const year = time.getFullYear();

      const hour = time.getHours().toString().padStart(2,'0');
      const minute = time.getMinutes().toString().padStart(2,'0');
      console.log(`${day}/${month}/${year} - ${hour}:${minute}`.length);
      
      return `${day}/${month}/${year} - ${hour}:${minute}`
      // return `${time.getHours().toString().padStart(2,'0')}:${time.getMinutes().toString().padStart(2,'0')}`
    }
    else {
      return ''
    }
  }

  public registrarDataFimEvento() {
    this.operacaoVazaoService.saveStrippingTime(this.id_operacao, this.id_operacaoLote, this.stripping)
    this.operacaoVazaoService.saveCowTime(this.id_operacao, this.id_operacaoLote, this.cowTime)
    this.dialogRef.close({ caladoSaida: this.caladoSaida });
  }

  public closeFunction(){
    this.dialogRef.close({ canceled: true });
  }

}
